import { render, staticRenderFns } from "./SendEmailChange.vue?vue&type=template&id=ff96042e&"
import script from "./SendEmailChange.vue?vue&type=script&lang=js&"
export * from "./SendEmailChange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports